import React from "react";
import { FormSections, FormSubSections, ProgramContainer } from "src/entities/formTemplateDataType";
import { SubSectionComponent } from "../SubSectionComponent";
import { parseJson, stringifyJson } from "../../utilities/JsonUtils";
//import { populateElementFindRoot } from "../../utilities/ElementUtils";

interface Props {
  programContainer: ProgramContainer;
  isEng:boolean
}

interface State {

}

export class SummaryComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);
   
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }

  render() {
    let ReviewHtmlString = [];
    const programContainer = parseJson(stringifyJson(this.props.programContainer, this.props.programContainer.CategoryId), this.props.programContainer.CategoryId) as ProgramContainer;
    //populateElementFindRoot(programContainer);

    const formSectionList =  programContainer.ListOfFormSections.filter(p => p.Visible);
    ReviewHtmlString.push( <h2 className="ontario-summary-h2 ontario-margin-top-24-! ontario-margin-bottom-24-!" style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }} key="summary_title">{this.props.isEng ? "Review your details" : "Vérifiez vos coordonnées"}</h2>);
    for (const section of formSectionList) {
      const subSectionList = section.ListOfFormSubSections;
        ReviewHtmlString.push(this.generateSubSectionHtml(section,subSectionList));
     }

    return ReviewHtmlString;

  }

  generateSubSectionHtml = (section,subSectionList) => {
    let ReviewHtmlString = [];

    for (const subSection of subSectionList) {
      let title = "";
      if (subSectionList.length == 1) {
         title = this.props.isEng ? section.ENUTitle : section.FRATitle
      } else {
        title = this.props.isEng ? subSection.ENUTitle : subSection.FRATitle
      }
 
      const elementsWithoutLabelField = subSection.ListOfFormSectionElements.filter(p => p.Datatype != 'Label' && p.Datatype !== 'Picture' 
        && p.Datatype !== 'HTML' && p.Datatype != 'Button' && p.Datatype != 'SuccessAlert' 
        && p.Datatype != 'ErrorAlert' && p.Datatype != 'InformationAlert' && p.Datatype !="HiddenField"
        && p.Datatype!="PublicSecureButton"  && p.Datatype!="PdfButton"  );
      if (elementsWithoutLabelField.length > 0) {
        subSection.ListOfFormSectionElements = elementsWithoutLabelField;
        ReviewHtmlString.push(
          <div key={"summary_" + subSection.Id} className="pdf-section" style={{ width: '100%', maxWidth: '100%' }}>
                 { // make the title background grey if horizontal layout
                    this.props.programContainer.isHorizontalLayout ?
                      <div className="ontario-bg-greyscale-40">
                        <span className="ontario-summary-h4">{this.props.isEng ? section.ENUTitle : section.FRATitle}</span>
                      </div> : <span className="ontario-summary-h4">{this.props.isEng ? section.ENUTitle : section.FRATitle}</span>}

            <SubSectionComponent
              key={'review_DetailComponent_' + subSection.Id}
              isEng={this.props.isEng}  {...this.props}
              activeSubSection={subSection}
              editable={false}
              user={null}
              topEntity={{}}
              roleBasedEditable={false}
              roleBased={false}
              callback={(e) => null}
              ownerEditableOnly={false} />
          </div>
        )
      }
    }

    return ReviewHtmlString;
  }
}
